import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    // Only scroll if the pathname actually changed
    if (prevPathname.current !== pathname) {
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        // First scroll the window
        window.scrollTo({ top: 0, behavior: 'instant' });
        
        // Then find and scroll specific containers
        // Only scroll main content containers, not all scrollable elements
        const mainContent = document.querySelector('.h-full.overflow-auto.pb-16');
        if (mainContent) {
          mainContent.scrollTo({ top: 0, behavior: 'instant' });
        }
      }, 0);
      
      // Update the previous pathname
      prevPathname.current = pathname;
    }
  }, [pathname]);

  return null;
}